import { useContext } from "react"
import { HOST } from "../constants/HostConstants"
import { AlertContext } from "../context/MainContext"

export const adverisementRequest = async (user_id, advertisement_url, direction, email_address, type) => {
    fetch(`${HOST}/api/advertisement/advertisementRequest`, {
        method: 'POST',
        body: JSON.stringify({
            user_id,
            advertisement_url,
            direction,
            email_address,
            type
        }),
        credentials: 'include',
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
        }
    }).then((res)=> res.json()).then(data=> {

    })
}